import { createRouter, createWebHashHistory } from 'vue-router';
import routes from './base';
// 引入公共js
import Common from '@/utils/common';
// 多语言
import VueI18n from '@/language/index';
// 加载对应翻译文件并设置翻译
import { setLanguage } from '@/language/set';

import * as Sentry from '@sentry/vue';
import { triggerOpenVconsole } from '@/utils/vconsole';

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: routes(),
});

router.beforeEach((to, from, next) => {
  // setLanguage('ar').then(()=>{
  //   Common.info.lang = 'ar';
  //   // 有对应的翻译标题才设置标题
  //   if(to.meta.setTitle){
  //     document.title = VueI18n.global.t(`routeTitle.${String(to.name)}`)
  //   }
  // })
  // 有对应的翻译标题才设置标题
  if (to.meta.setTitle) {
    document.title = VueI18n.global.t(`routeTitle.${String(to.name)}`);
  }
  if (sessionStorage.getItem('uid') && sessionStorage.getItem('ticket') && sessionStorage.getItem('language')) {
    // 多语言设置
    setLanguage(sessionStorage.getItem('language')).then(() => {
      Common.info.lang = sessionStorage.getItem('language') as string;
      Common.info.uid = sessionStorage.getItem('uid') as string;
      Common.info.ticket = sessionStorage.getItem('ticket') as string;
      // 有对应的翻译标题才设置标题
      if (to.meta.setTitle) {
        document.title = VueI18n.global.t(`routeTitle.${String(to.name)}`);
      }
      next();
    });
  } else {
    if (Common.browser.app) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const apf = new Promise(function (resolve, reject) {
        window.appFun('getUid', function (e: string) {
          Common.info.uid = e;
          triggerOpenVconsole(Number(e)); //线上白名单显示控制台
          window.appFun('getTicket', function (e: string) {
            Common.info.ticket = e;
            window.appFun('getLanguage', function (e: string) {
              Common.info.lang = e;
              // 多语言设置
              setLanguage(e).then(() => {
                // 有对应的翻译标题才设置标题
                if (to.meta.setTitle) {
                  document.title = VueI18n.global.t(`routeTitle.${String(to.name)}`);
                }
                resolve('ok');
              });
            });
          });
        });
      });
      apf.then((res) => {
        console.log(res);
        sessionStorage.setItem('uid', Common.info.uid as string);
        sessionStorage.setItem('ticket', Common.info.ticket);
        sessionStorage.setItem('language', Common.info.lang);
        Sentry.setUser({
          id: Common.info.uid,
        });
        console.log(Common.info);
        next();
      });
    } else {
      sessionStorage.setItem('uid', Common.info.uid as string);
      sessionStorage.setItem('ticket', Common.info.ticket);
      sessionStorage.setItem('language', Common.info.lang);
      console.log(Common.info, '非Common.browser.app');
      next();
    }
  }
});

export default router;
